type NavigateToTarget = (target: Element) => boolean;

const menus = new Map<Element, NavigateToTarget>();

export function registerAnchorMenu(menu: Element, navigate: NavigateToTarget): void {
    menus.set(menu, navigate);
}

export function unregisterAnchorMenu(menu: Element): void {
    menus.delete(menu);
}

// Let the owning menu apply the same thresholds and post-scroll correction as a click.
export function scrollToAnchorMenuTarget(target: Element): boolean {
    return [...menus.values()].some((navigate) => navigate(target));
}

// The anchor menu margin includes its top offset for panels above it.
// Take the larger margin to avoid counting those panels twice.
export function getStickyScrollMargin(): number {
    const anchorMenuMargin = parseFloat(
        getComputedStyle(document.body).getPropertyValue('--anchor-menu-scroll-margin'),
    ) || 0;

    const otherStickyHeight = Array.from(document.querySelectorAll<HTMLElement>('.directive-v-sticky:not(.s-anchor-menu)'))
        .reduce((height, sticky) => height + (sticky.offsetHeight || 0), 0);

    return Math.max(anchorMenuMargin, otherStickyHeight);
}
